var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

Shopify.money_format = "${{amount}}";

Shopify.formatMoney = function (cents, format) {
	if (typeof cents == 'string') { cents = cents.replace('.', ''); }
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);
	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}
	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');
		if (isNaN(number) || number == null) { return 0; }
		number = (number / 100.0).toFixed(precision);
		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? (decimal + parts[1]) : '';
		return dollars + cents;
	}
	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}
	return formatString.replace(placeholderRegex, value);
};

 // free shipping js start
 function freeShipping(){
    $.getJSON('/cart.js', function(cart) {
      if(cart.item_count > 0){
        setTimeout(function(){
          var shipping_value = $('.drawer-freeshipping').attr('data-shipping-price');
          var total_away = parseFloat(shipping_value) - parseFloat((cart.original_total_price / 100)); 
          total_away = total_away * 100;
          if(total_away > 0) {
            var this_formate = $('.cart_free-shipping').attr('data-money-format');
            $('.cart_free-shipping').html("<p>You are " + "<span>" + Shopify.formatMoney(total_away,this_formate) + "</span>" + " away from free shipping!</p>");
          } else {
            $('.cart_free-shipping').html("<p>Congratulations! You have free shipping.</p>");
          }
        }, 500);
      }
    });
 }
//free shipping js end

// Function for side cart start
function do_cart_refresh() {
	$.ajax({
		url: "/cart.json",
		method: "GET",
		success: function (cartdata) {
			window.cartdata = cartdata;
			if (cartdata.item_count == 0) {
				$(".cart_product_wrapper").hide();
				$(".popupsubttl").hide();
				$(".emty_msg").show();
				$('.js-cart-count').text(cartdata.item_count);

			} else {

				var cart_markup = "";
				var cart_total = 0;
				$(cartdata.items).each(function (ix, em) {
					let current_line_price = 0;
					if (em.properties != null && typeof em.properties._ro_unformatted_price !== 'undefined') {
						current_line_price = em.quantity * parseInt(em.properties._ro_unformatted_price);
					} else {
						current_line_price = em.quantity * parseInt(em.original_price);
					}
					cart_total += current_line_price;
					var price = Shopify.formatMoney(current_line_price, $('body').data('money-format'))
					cart_markup += `<div class="d-flex cart_detail-popup">
                		  <div class='proimg-wrap'>
                		  <div class="proimg-cart">
                      		<img class="lazyload" alt="proimg2" src="${em.image}" width="150" height="150">
                      	  </div>
                		  <div class="close_btn"  data-remove>
                				<a href="#" class= "js-remove"   data-variantid="${em.key}">
                             Remove
                			</a></div>
                			</div>
                
                   		 <div class="prodetail pl-3" data-var = "${em.id}">
                      	<h4 class="semibold proname mb-3"  ><a href="${em.url}">${em.title}</a></h4>
                       <h4 class="pricepop">${price}</h4>
                     	 <div class="qtybtns mb-3" data-var = "${em.id}">                         
                        <div class="quantity buttons_added" data-itemqty="${em.quantity}" data-var = "${em.id}">
                          <button class="minus" type="button">-</button>
                         <input class="input-text qty text"  max="" min="1" name="quantity" pattern="" size="2" step="1" title="Qty" type="number" data-qty-id="${em.id}" value="${em.quantity}">
                         <button class="plus" type="button" data-qty-id="${em.id}">+</button>
                        </div>
                      </div>
                      
                    </div>
                  </div>`;
				});
				$(".cart_product_wrapper").html(cart_markup);
				$(".js-gross-total").text(Shopify.formatMoney(parseFloat(cart_total), $('body').data('money-format')));
				$(".popupsubttl").show();
				$(".cart_product_wrapper").show();
				$(".emty_msg").hide();
				$('.js-cart-count').text(cartdata.item_count);
			}
			$('.cartpopup').addClass('activepopup');
			$('body').addClass('open_modal_custom');
          freeShipping();
		}
	});
   
}
// Function for side cart end

$(document).ready(function(){
  freeShipping();
  String.prototype.getDecimals || (String.prototype.getDecimals = function () {
		var a = this,
			b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
		return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
	});
	$(document).on('click',".plus, .minus", function () {
		var a = jQuery(this).closest(".quantity").find(".qty"),
			b = parseFloat(a.val()),
			c = parseFloat(a.attr("max")),
			d = parseFloat(a.attr("min")),
			e = a.attr("step");
		b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")
		a.attr('value', a.val());
	});
});

$(document).on('click', '.js-remove', function (e) {
  e.preventDefault();

  let variant_id = $(e.target).attr('data-variantid');
  let quantity = 0;
  let current_item = {};
  current_item[variant_id] = 0;
  $.ajax({
    url: "/cart/update.js",
    data: { 'updates': current_item },
    dataType: "JSON",
    method: "POST",
    success: function (cartdata) {
      do_cart_refresh(cartdata);
    }
  });
});

$(document).ready(function () {
	function updateCart_item($this) {
		var $parent = $this.parents('.cartItemContent');

		var id = $parent.attr('data-var');
		var qty = $parent.find('input[name="quantity"]').val();
		$.ajax({
			url: '/cart/change.js',
			data: { quantity: qty, line: id },
			dataType: 'json',
			success: function (data) {

				jQuery.getJSON('/cart.js', function (data) {
					do_cart_refresh(data);
				});
			},
            error: function(err){
              alert(err.responseJSON.description);
            }
		});
	}

	$(document).on('change', '[name="quantity"]', function (e) {
      console.log(123)
		var cur_em = e.target;
		var parent_em = $(cur_em).parents('[data-var]').eq(0);
		var cur_qty = $(cur_em).val();
		var variant_id = $(cur_em).parents('[data-var]').eq(0).attr('data-var');
      console.log($(this).parent().data("itemqty"))
        var item_qty_available = $(this).parent().data("itemqty");
        $(this).val(item_qty_available);
		$.ajax({
			url: "/cart/change.js",
			data: { id: variant_id, quantity: cur_qty },
			dataType: "JSON",
			method: "POST",
			success: function (data) {
				$.get('/cart.json', function (data) {
					do_cart_refresh(data);
				});
			},
            error: function(err){
              alert(err.responseJSON.description);
            }
		})
	});
});

// $(document).ready(function () {
//   $(document).on('click', '.product-single__meta .purchase-section input[type="submit"]', function(e){
//     e.preventDefault();
//     var data = $(this).parents('form').serialize();
//     var qty = $(".qty_selector input[type='number']").val();;
//     $.ajax({
//       url: '/cart/add.js',
//       type: 'POST',
//       dataType: 'json',
//       data: data,
//       success: function(data) { 
//         console.log(data);
//         do_cart_refresh();
//       }
//     });
//     return false;
//   });
// });
